<template>
  <div>
    <!-- assign ref property to access the underlying functions -->
    <!-- all cropperjs options should be in kebab-case instead of camelCase -->
    <!-- all cropperjs events should be in lowercase instead of camelCase -->
    <!-- see http://vuejs.org/guide/components.html#camelCase-vs-kebab-case -->

    <v-row align="center" justify="center">
      <v-col cols="6" md="6">
        <v-card class="grey lighten-4 pa-4">
          <v-card-text>
            <div class="cropper-container" ref="cropperImage">
              <VueCropper
                ref="cropper"
                :view-mode="3"
                :src="imgSrc"
                @ready="updatePreview"
                @cropmove="updatePreview"
                :aspect-ratio="cropperAspectRatio"
                :class="cropperFace"
                :auto-crop-area="1"
              >
              </VueCropper>
            </div>

            <div>
              <v-slider
                v-model="zoomValue"
                track-color="grey"
                :min="1"
                :max="10"
                class="mt-1"
                @start="initialValue($event)"
                @input="updateZoom($event)"
              >
                <template v-slot:prepend>
                  <div>
                    <v-icon class="pt-2" small> mdi-image </v-icon>
                  </div>
                </template>
                <!-- <template v-slot:progress>
                    <div class="pt-2">
                      <p>progress</p>
                    </div>
                  </template> -->
                <template v-slot:append>
                  <div>
                    <v-icon> mdi-image </v-icon>
                  </div>
                </template>
              </v-slider>
            </div>

            <div class="d-flex justify-space-around align-center">
              <input
                type="file"
                ref="file"
                style="display: none"
                @change="setImage"
              />

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    color="white"
                    class="elevation-5"
                    size="25"
                    v-bind="attrs"
                    v-on="on"
                    @click="handleChangeImage"
                  >
                    <v-icon small>mdi-image</v-icon>
                  </v-avatar>
                </template>
                <span> Change image </span>
              </v-tooltip>

              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="white" class="elevation-5" size="25" v-bind="attrs" v-on="on" @click="flipX">
                    <v-icon small>mdi-flip-horizontal</v-icon>
                  </v-avatar>
                </template>
                <span>
                  Flip X
                </span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar color="white" class="elevation-5" size="25" v-bind="attrs" v-on="on" @click="flipY">
                    <v-icon small>mdi-flip-vertical</v-icon>
                  </v-avatar>
                </template>
                <span>Flip y </span>
              </v-tooltip> -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    color="white"
                    class="elevation-5"
                    size="25"
                    v-bind="attrs"
                    v-on="on"
                    @click="rotate(90)"
                  >
                    <v-icon small>mdi-rotate-left</v-icon>
                  </v-avatar>
                </template>
                <span> Rotate left</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    color="white"
                    class="elevation-5"
                    size="25"
                    v-bind="attrs"
                    v-on="on"
                    @click="rotate(90)"
                  >
                    <v-icon small>mdi-rotate-right</v-icon>
                  </v-avatar>
                </template>
                <span>Rotate right</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    color="white"
                    class="elevation-5"
                    size="25"
                    v-bind="attrs"
                    v-on="on"
                    @click="reset"
                  >
                    <v-icon small>mdi-restart</v-icon>
                  </v-avatar>
                </template>
                <span>Reset</span>
              </v-tooltip>
              <v-tooltip bottom v-if="previewType == 'logoImageURL'">
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    color="white"
                    class="elevation-5"
                    size="25"
                    v-bind="attrs"
                    v-on="on"
                    @click="changeLogoFrame"
                  >
                    <v-icon small>mdi-arrow-expand</v-icon>
                  </v-avatar>
                </template>
                <span>Change logo frame</span>
              </v-tooltip>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
        md="6"
        :class="{
          'd-flex justify-center align-center':
            previewType == 'displayImageURL' ||
            previewType == 'square' ||
            previewType == 'rectangle' ||
            previewType == 'potrait',
        }"
      >
        <div
          class="business-card-container"
          v-if="
            previewType != 'displayImageURL' &&
            previewType != 'thumbnail' &&
            previewType != 'square' &&
            previewType != 'rectangle' &&
            previewType != 'potrait'
          "
        >
          <BusinessCardRotator
            :cardCorners="businessProfile.card_corners"
            :logoFrame="logoFrame"
            :logoImageURL="
              previewType == 'logoImageURL'
                ? previewImg
                : businessProfile.logo_image_url
            "
            :reverseImageURL="
              previewType == 'reverseImageURL'
                ? previewImg
                : businessCardRotatorObject.reverseImageURL
            "
            :backgroundImageURL="
              previewType == 'backgroundImageURL'
                ? previewImg
                : businessCardRotatorObject.backgroundImageURL
            "
            :hideToggleControl="true"
            :businessCardSideProp="
              previewType == 'reverseImageURL' ||
              previewType == 'backgroundImageURL'
                ? 1
                : 0
            "
          />
        </div>

        <!--Start: Show circular preview-->
        <v-card
          v-if="previewType == 'displayImageURL'"
          class="logo-frame-circle circle"
          outlined
          width="200"
          height="200"
        >
          <v-img :src="previewImg" width="200" height="200"></v-img>
        </v-card>
        <!--End: Show circular preview-->

        <!--Start: Square preview-->
        <v-card
          v-if="previewType == 'square'"
          class="rouned-md"
          outlined
          width="200"
          height="200"
        >
          <v-img :src="previewImg" width="200" height="200"></v-img>
        </v-card>
        <!--End:  Square preview-->

        <!--Start: Thumbnail preview-->
        <div v-if="previewType == 'thumbnail'">
          <v-card
            elevation="5"
            rounded="lg"
            max-width="245.7"
            max-height="245.7"
          >
            <v-img :src="previewImg" :aspect-ratio="378 / 250"></v-img>
            <div class="text-subtitle-1 pt-3 pl-3 pb-3 text-capitalize">
              {{ link.title == "" ? "Untitled Link" : link.title }}
            </div>
          </v-card>
        </div>
        <!--End: Thumbnail preview-->

        <!---Start: Show rectangular preview--->
        <!-- <v-card class="pa-0"  outlined> -->
        <img
          :src="previewImg"
          v-if="previewType == 'rectangle'"
          style="aspect-ratio: 378/250; min-height: 125px; min-width: 189px"
          class="outlined-border ma-2 rounded-lg"
        />
        <!-- </v-card> -->
        <!---End: Show rectangular preview--->

        <!--Start: Potrait preview-->
        <img
          :src="previewImg"
          v-if="previewType == 'potrait'"
          style="aspect-ratio: 9/16; min-height: 200px; max-height: 500px"
          class="outlined-border ma-2 rounded-lg"
        />
        <!--End: Potrait preview-->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn
          width="150"
          color="primary"
          depressed
          large
          class="text-body-1"
          @click="uploadImage"
          >Upload</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Uploading image
          <v-progress-linear
            color="white"
            class="mb-0"
            :value="imageUploadProgress"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import BusinessCardRotator from "@/components/BusinessCardRotator";
import { mapGetters, mapActions } from "vuex";
import {getDownloadUrlForRef, getStorageRef, uploadStringInStorage} from "@/shared/firebase_utils";

let uuid = require("uuid");

export default {
  components: { VueCropper, BusinessCardRotator },
  props: {
    selectedImage: { type: String },
    previewType: { type: String },
    link: { type: Object },
    selectedLogoFrame: { type: String, default: "logo-frame-circle" },
    businessCardRotatorObject: { type: Object },
  },
  created() {
    this.imgSrc = this.selectedImage;
    this.logoFrame = this.selectedLogoFrame;
  },
  data() {
    return {
      scaleX: 1,
      scaleY: 1,
      zoomValue: 0,
      initialZoom: 0,
      previewImg: "",
      imageUploadProgress: 0,
      loadingDialog: false,
      imgSrc: "",
      logoFrame: "logo-frame-circle",
    };
  },
  computed: {
    ...mapGetters(["businessProfile"]),
    cropperFace() {
      let className = "logo-transition";
      if (
        this.previewType == "logoImageURL" &&
        this.logoFrame == "logo-frame-circle"
      )
        className = "circular-cropper logo-transition";

      if (this.previewType == "displayImageURL")
        className = "circular-cropper logo-transition";

      return className;
    },

    cropperAspectRatio() {
      let aspectRatio = 378 / 250;
      if (this.previewType == "displayImageURL") aspectRatio = 1 / 1;
      if (
        this.previewType == "logoImageURL" &&
        this.logoFrame != "logo-frame-rectangle"
      )
        aspectRatio = 1 / 1;
      if (this.previewType == "square") aspectRatio = 1 / 1;
      if (this.previewType == "potrait") aspectRatio = 9 / 16;

      return aspectRatio;
    },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    // zoom() {
    //   console.log("change");
    //   let zoomRatio = parseFloat(this.zoomValue - this.initialZoom) * 0.1;
    //   this.$refs.cropper.relativeZoom(zoomRatio);
    //   this.updatePreview();
    // },
    flipX() {
      this.scaleX = this.scaleX == 1 ? -1 : 1;
      this.$refs.cropper.scaleX(this.scaleX);
      this.updatePreview();
    },
    flipY() {
      this.scaleY = this.scaleY == 1 ? -1 : 1;
      this.$refs.cropper.scaleY(this.scaleY);
      this.updatePreview();
    },
    reset() {
      this.$refs.cropper.reset();
      this.zoomValue = 1;
      this.updatePreview();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
      this.updatePreview();
    },
    initialValue(initialZoom) {
      this.initialZoom = initialZoom;
    },
    changeLogoFrame() {
      switch (this.logoFrame) {
        case "logo-frame-circle":
          this.logoFrame = "logo-frame-square";
          this.$refs.cropper.setAspectRatio(1 / 1);
          break;
        case "logo-frame-square":
          this.logoFrame = "logo-frame-rectangle";
          this.$refs.cropper.setAspectRatio(378 / 250);
          break;
        case "logo-frame-rectangle":
          this.logoFrame = "logo-frame-circle";
          this.$refs.cropper.setAspectRatio(1 / 1);

          break;
        default:
          this.logoFrame = "logo-frame-circle";
      }
    },
    updatePreview() {
      this.previewImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    async uploadImage() {
      try {
        this.loadingDialog = true;
        //create a unique file name
        const imageName = uuid.v1();
        const metaData = {
          contentType: "image/png",
        };

        //Get a firebase storage reference
        const imageRef = getStorageRef(`images/${imageName}.png`);
        const uploadTask = await uploadStringInStorage(
            imageRef,
          this.previewImg,
          "data_url",
          metaData
        );
        getDownloadUrlForRef(uploadTask.ref).then((downloadURL) => {
          this.showSnackbar({
            show: true,
            text: "Image saved successfully!",
          });
          this.$emit("uploaded", downloadURL, this.logoFrame);
          this.loadingDialog = false;
        });
        /*uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case 'paused': // or 'paused'
                console.log("Upload is paused");
                break;
              case 'running': // or 'running'
                this.imageUploadProgress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.showSnackbar({
                show: true,
                text: "Image saved successfully!",
              });

              this.$emit("uploaded", downloadURL, this.logoFrame);
              this.loadingDialog = false;
            });
          }
        );*/
      } catch (error) {
        this.loadingDialog = false;
        console.log("Error occurred while uploading the image ", error);
      }
    },
    handleChangeImage() {
      this.$refs.file.click();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        this.showSnackbar({ show: true, text: "Please select an image!" });
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.showSnackbar({
          show: true,
          text: "Could not select image from file system",
        });
        console.log("Error occurred: FileReader API not supported");
      }
    },
    updateZoom(updatedZoomValue) {
      let zoomRatio = parseFloat(updatedZoomValue) * 0.05;
      this.$refs.cropper?.zoomTo(zoomRatio);
      this.updatePreview();
    },
  },
};
</script>
<style>
.circle {
  border-radius: 50% !important;
}

/* Ensure the size of the image fits the container perfectly */
.cropper-container {
  display: block;
  max-width: 100%;
}

.cropper-container img {
  /* This is important, please don't change this */
  width: 100%;
}

/*Start: Circular crop-box */
.circular-cropper .cropper-view-box,
.circular-cropper .cropper-face {
  border-radius: 50% !important;
}

.circular-cropper .cropper-dashed,
.circular-cropper .cropper-point.point-se,
.circular-cropper .cropper-point.point-sw,
.circular-cropper .cropper-point.point-nw,
.circular-cropper .cropper-point.point-ne,
.circular-cropper .cropper-line {
  display: none !important;
}

.circular-cropper .cropper-view-box {
  outline: inherit !important;
}
/*End: Circular crop-box */

.border-default {
  border: 1px solid #e0e0e0 !important;
}

.logo-transition {
  transition-duration: 350ms;
  transition-property: height, width, border-radius;
  transition-timing-function: ease-out;
}

.cropper-crop-box,
.cropper-face {
  transition-duration: 350ms;
  transition-property: height, width, border-radius;
  transition-timing-function: ease-out;
}
</style>